import GiftSummaryContent from "./GiftSummaryContent";

export default GiftSummaryContent;
